/**
 * Scroll reveals and hero parallax.
 *
 * Syntax note: gulp-babel runs with no preset, so this source reaches
 * uglify-js as written. No optional chaining (?.) or nullish coalescing
 * (??) — they break the build.
 */

/* =========================================================
   SCROLL REVEALS
   ========================================================= */
(function () {
  const targets = document.querySelectorAll(".reveal, .reveal-stagger");
  if (!targets.length) return;
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Revealed elements start at opacity 0, so when motion is not wanted they
  // must be switched on immediately rather than simply left alone.
  if (reduceMotion || !("IntersectionObserver" in window)) {
    for (let i = 0; i < targets.length; i++) {
      targets[i].classList.add("is-in");
    }
    return;
  }
  const io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add("is-in");
      io.unobserve(entry.target); // reveal once, not on every pass
    });
  }, {
    threshold: 0.15,
    rootMargin: "0px 0px -8% 0px"
  });
  for (let i = 0; i < targets.length; i++) {
    io.observe(targets[i]);
  }
})();

/* =========================================================
   HERO PARALLAX + HEADLINE DRIFT

   The header's own scroll state is handled in _tlr-header.js; this only
   moves the hero art and copy.
   ========================================================= */
(function () {
  const bg = document.getElementById("heroBg");
  const wrap = document.getElementById("heroStickyWrap");
  if (!bg && !wrap) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  let ticking = false;
  function apply() {
    const y = window.pageYOffset || document.documentElement.scrollTop;
    if (bg) {
      bg.style.transform = "translateY(" + y * 0.3 + "px)";
    }
    if (wrap) {
      // Copy lifts and fades out across the first 80% of the viewport.
      const progress = Math.min(1, Math.max(0, y / (window.innerHeight * 0.8)));
      wrap.style.transform = "translateY(" + -progress * 60 + "px)";
      wrap.style.opacity = String(1 - progress * 0.85);
    }
    ticking = false;
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(apply);
  }
  window.addEventListener("scroll", onScroll, {
    passive: true
  });
  apply(); // restore the right state when reloading mid-page
})();